module.exports = __webpack_public_path__ + "static/media/Bitmap@1x.65f5d6c0.png";